import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarAuroraProjectDesignsDto } from "../dto/solar-proposal-aurora.dto"
import { solarProposalAuroraService } from "../services/solar-proposal-aurora.service"

/**
 * The designs in the proposal's Aurora project. Each fetch is an Aurora call,
 * so it waits until `enabled` (the Versions tab is open) and isn't retried.
 */
export default function useSolarAuroraProjectDesigns(
  proposalId: string | undefined,
  { enabled }: { enabled: boolean },
): UseQueryResult<SolarAuroraProjectDesignsDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.auroraProjectDesigns(proposalId ?? ``),
    queryFn: () =>
      solarProposalAuroraService.getProjectDesigns(proposalId ?? ``),
    enabled: enabled && Boolean(proposalId),
    retry: false,
  })
}
